<template>
  <div>
    <!-- 顶部导航栏信息 -->
    <div class="header">
      <span @click="goOut"></span>
      <span class="music-t">
        <music />
      </span>
      <span>毁形照</span>
      <span @click="islogout">退出</span>
    </div>
    <div style="margin-top: 40px">
      <van-tabs sticky offset-top="40" color="#1989fa" v-model="activeTabs">
        <van-tab title="车辆信息列表" name="list">
          <div class="car-list-search">
            <van-field
              style="width: 75%"
              :border="true"
              label="车牌号："
              placeholder="请输入车牌号进行搜索~"
              label-width="70"
              clearable
              maxlength="8"
              v-model="carPlate"
            />
            <van-button
              style="margin-left: 20px"
              type="info"
              round
              icon="search"
              size="small"
              @click="getCarListData(carPlate)"
              >搜索</van-button
            >
          </div>
          <div v-if="carListData.length">
            <div
              class="car-list-item"
              v-for="(item, index) in carListData"
              :key="index"
            >
              <div class="item-edge-distance">
                <div class="item-icon">
                  <van-icon
                    name="records"
                    color="orange"
                    size="21"
                    @click="editCarInfo(item, index)"
                  />
                </div>
                <van-field
                  label="车牌号："
                  placeholder=""
                  readonly
                  v-model="item.carNumberPlate"
                ></van-field>
                <van-field
                  label="车架号："
                  placeholder=""
                  readonly
                  v-model="item.vin"
                ></van-field>
              </div>
            </div>
          </div>
          <div style="text-align: center" v-else>
            <div>
              <van-nodata
                :figure="2"
                title="标题"
                tip="提示"
                button="按钮文本"
              />
            </div>
            <div>
              <img src="http://mui.ucmed.cn/images/nodata/nofind.png" alt="" />
            </div>
            <div style="color: #646566">暂无数据~</div>
          </div>
        </van-tab>
        <van-tab title="车辆信息录入" name="type-in">
          <!-- 车牌号搜索区域 -->
          <div
            style="display: flex; align-items: center"
            class="car-list-search"
          >
            <van-field
              style="width: 75%"
              label="车牌号："
              label-width="70"
              clearable
              maxlength="8"
              v-model="isData.carNumberPlate"
            />
            <van-button
              style="margin-left: 10px"
              type="info"
              round
              icon="search"
              size="small"
              @click="searchCarInfo"
              >搜索</van-button
            >
          </div>
          <!-- 车架号 -->
          <van-field
            style="display: flex; align-items: center; width: 75%"
            label="Vin："
            label-width="70"
            clearable
            v-model="vindata"
          />
          <!-- 车辆照片&视频区域 -->
          <div class="content-box">
            <van-collapse v-model="activeNames">
              <van-collapse-item title="车辆照片信息:" name="1">
                <div class="img-box">
                  <!-- 整车照片 -->
                  <div style="" class="img-item">
                    <div>整车照片</div>
                    <!-- 非微信端的时候上传图片 -->
                    <van-uploader
                      v-if="!isWechat"
                      class="uploader"
                      v-model="entireCarImgList"
                      :after-read="uploadershang('du')"
                      :before-delete="deleteimg(1)"
                      :max-count="1"
                      upload-text="点击上传"
                    >
                    </van-uploader>
                    <!-- 微信端上传图片 -->
                    <div v-else>
                      <!-- 没有图片时 -->
                      <van-image
                        v-if="!wxEntireCarPhotos"
                        style="width: 100px; height: 100px"
                        :src="wxEntireCarPhotos"
                        @click="WeChooseImage(1, '45Degrees')"
                      >
                        <template v-slot:error>
                          <div>
                            <van-icon
                              style="margin-top: -6px"
                              name="photograph"
                              size="20"
                              color="#dcdee0"
                            />
                          </div>
                          <div style="font-size: 10px; margin-top: 2px">
                            暂无图片
                          </div>
                        </template>
                      </van-image>
                      <!-- 有图片时 -->
                      <van-image
                        v-else
                        style="width: 100px; height: 100px"
                        :src="wxEntireCarPhotos"
                        @click="bigImg(wxEntireCarPhotos)"
                      >
                        <van-icon
                          class="iconX"
                          name="cross"
                          @click.stop="delImgHan('45Degrees')"
                        ></van-icon>
                      </van-image>
                    </div>
                  </div>
                  <!-- 毁形照片 -->
                  <div style="" class="img-item">
                    <div>毁形照片</div>
                    <van-uploader
                      v-if="!isWechat"
                      class="uploader"
                      v-model="unmakeImgList"
                      :after-read="uploadershang('hui')"
                      :before-delete="deleteimg(2)"
                      :max-count="1"
                      upload-text="点击上传"
                    >
                    </van-uploader>
                    <div v-else>
                      <van-image
                        v-if="!wxUnmakePhotos"
                        style="width: 100px; height: 100px"
                        :src="wxUnmakePhotos"
                        @click="WeChooseImage(1, 'hui')"
                      >
                        <template v-slot:error>
                          <div>
                            <van-icon
                              style="margin-top: -6px"
                              name="photograph"
                              size="20"
                              color="#dcdee0"
                            />
                          </div>
                          <div style="font-size: 10px; margin-top: 2px">
                            暂无图片
                          </div>
                        </template>
                      </van-image>
                      <van-image
                        v-else
                        style="width: 100px; height: 100px"
                        :src="wxUnmakePhotos"
                        @click="bigImg(wxUnmakePhotos)"
                      >
                        <van-icon
                          class="iconX"
                          name="cross"
                          @click.stop="delImgHan('hui')"
                        ></van-icon>
                      </van-image>
                    </div>
                  </div>
                  <!-- Vin照片 -->
                  <div style="" class="img-item">
                    <div>Vin照片</div>
                    <van-uploader
                      class="uploader"
                      v-model="vinImgList"
                      :after-read="uploadershang('vin')"
                      :before-delete="deleteimg(3)"
                      :max-count="1"
                      upload-text="点击上传"
                    >
                    </van-uploader>
                    <div v-if="false">
                      <van-image
                        v-if="!wxVinPhotos"
                        style="width: 100px; height: 100px"
                        :src="wxVinPhotos"
                        @click="WeChooseImage(1, 'Vin')"
                      >
                        <template v-slot:error>
                          <div>
                            <van-icon
                              style="margin-top: -6px"
                              name="photograph"
                              size="20"
                              color="#dcdee0"
                            />
                          </div>
                          <div style="font-size: 10px; margin-top: 2px">
                            暂无图片
                          </div>
                        </template>
                      </van-image>
                      <van-image
                        v-else
                        style="width: 100px; height: 100px"
                        :src="wxVinPhotos"
                        @click="bigImg(wxVinPhotos)"
                      >
                        <van-icon
                          class="iconX"
                          name="cross"
                          @click.stop="delImgHan('Vin')"
                        ></van-icon>
                      </van-image>
                    </div>
                  </div>
                  <!-- 断梁照片 -->
                  <div style="" class="img-item">
                    <div>断梁照片</div>
                    <van-uploader
                      v-if="!isWechat"
                      class="uploader"
                      v-model="breakBeamImgList"
                      :after-read="uploadershang('duan')"
                      :before-delete="deleteimg(4)"
                      :max-count="1"
                      upload-text="点击上传"
                    >
                    </van-uploader>
                    <div v-else>
                      <van-image
                        v-if="!break_beam_photos"
                        style="width: 100px; height: 100px"
                        :src="break_beam_photos"
                        @click="WeChooseImage(1, 'duan')"
                      >
                        <template v-slot:error>
                          <div>
                            <van-icon
                              style="margin-top: -6px"
                              name="photograph"
                              size="20"
                              color="#dcdee0"
                            />
                          </div>
                          <div style="font-size: 10px; margin-top: 2px">
                            暂无图片
                          </div>
                        </template>
                      </van-image>
                      <van-image
                        v-else
                        style="width: 100px; height: 100px"
                        :src="break_beam_photos"
                        @click="bigImg(break_beam_photos)"
                      >
                        <van-icon
                          class="iconX"
                          name="cross"
                          @click.stop="delImgHan('duan')"
                        ></van-icon>
                      </van-image>
                    </div>
                  </div>
                  <!-- 其它照片 -->
                  <div style="" class="img-item">
                    <div>其它照片</div>
                    <van-uploader
                      v-if="!isWechat"
                      class="uploader"
                      v-model="otherImgList"
                      :after-read="uploadershang('other')"
                      :before-delete="deleteimg(5)"
                      :max-count="1"
                      upload-text="点击上传"
                    >
                    </van-uploader>
                    <div v-else>
                      <van-image
                        v-if="!otherImgurl"
                        style="width: 100px; height: 100px"
                        :src="otherImgurl"
                        @click="WeChooseImage(1, 'other')"
                      >
                        <template v-slot:error>
                          <div>
                            <van-icon
                              style="margin-top: -6px"
                              name="photograph"
                              size="20"
                              color="#dcdee0"
                            />
                          </div>
                          <div style="font-size: 10px; margin-top: 2px">
                            暂无图片
                          </div>
                        </template>
                      </van-image>
                      <van-image
                        v-else
                        style="width: 100px; height: 100px"
                        :src="otherImgurl"
                        @click="bigImg(otherImgurl)"
                      >
                        <van-icon
                          class="iconX"
                          name="cross"
                          @click.stop="delImgHan('other')"
                        ></van-icon>
                      </van-image>
                    </div>
                  </div>
                </div>
              </van-collapse-item>

              <van-collapse-item title="毁形视频:" name="2">
                <div class="content-up">
                  <div
                    class="videobox"
                    v-for="(item, index) in destruction_video"
                    :key="index"
                  >
                    <van-icon
                      class="iconX"
                      name="close"
                      @click="iconClose(index)"
                    />
                    <video
                      class="videoP"
                      :src="item"
                      v-if="destruction_video.length != 0"
                      playsinline="true"
                      controls="true"
                      autoplay
                      webkit-playsinline="true"
                      preload="auto"
                      type="video/mp4"
                      x-webkit-airplay="allow"
                      x5-video-player-type="h5"
                      x5-video-player-fullscreen="true"
                      x5-video-orientation="portraint"
                      style="object-fit: fill"
                    ></video>
                  </div>
                  <van-uploader
                    :after-read="afterRead"
                    :before-read="beforeRead"
                    v-model="fileList3"
                    accept="video/*"
                    :preview-image="false"
                    upload-text="点击上传视频"
                  >
                  </van-uploader>
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
          <vehicleInfo
            :ischu="ischu"
            ref="infoCarRef"
            :isData="isData"
            :vindata="vindata"
            @infoOk="infoOk"
            @saveTypeInInfo="saveTypeInInfo"
          />
          <p
            v-if="ischu == 2 && isdefault == '是'"
            class="opopzi"
            @click="enteringMore"
          >
            录入更多资料
          </p>
          <p
            v-if="ischu == 1 && isdefault == '是'"
            class="opopzi"
            @click="ischu = 2"
          >
            隐藏更多资料
          </p>
          <!-- <van-button
            v-if="isdefault == '否'"
            class="content-btn"
            type="info"
            size="large"
            @click="onsubmit"
            >完成</van-button
          > -->

          <van-popup
            :closeable="true"
            v-model="voiceShow"
            class="popup"
            :close-on-click-overlay="false"
          >
            <p style="text-align: center">是否语音播报</p>
            <hr />

            <div class="btn-ok">
              <van-button @click="voiceShow = false">取消</van-button>
              <van-button type="info" @click="playVoice">确定</van-button>
            </div>
          </van-popup>
          <audio :src="voice" id="audio" ref="audioRef"></audio>
          <van-popup
            v-model="CarInfoShow"
            closeable
            :close-on-click-overlay="false"
            position="bottom"
            :style="{ height: '100%', width: '100%' }"
          >
            <div class="title_car">车辆列表</div>
            <ObtainCarInfo
              ref="ObtainRef"
              :repetition="repetition"
              @colosepopup="colosepopup"
              :vin="vindata"
              @comeWei="comeWei"
              @upDate="upDate"
            />
          </van-popup>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { is_post } from "../../Http/api.js";
import { deleteCookie } from "@/utils/env";
import music from "../../components/music.vue";
import vehicleInfo from "@/components/vehicleInfo";
import { encipherMent } from "@/utils/encrypt";
import { PlateNum, selVehicLesInfo } from "@/api/carInfo";
import ObtainCarInfo from "@/components/ObtainCarInfo";
import wx from "weixin-js-sdk";
export default {
  components: {
    music,
    ObtainCarInfo,
    vehicleInfo,
  },
  data() {
    return {
      activeTabs: "info", // tabs名称
      activeNames: ["1", "2"], //折叠面板展开name
      isData: {
        carNumberPlate: "", // 车牌号
      },
      vindata: "", // 车架号
      entireCarImgList: [], // 非微信端整车照
      unmakeImgList: [], // 非微信端毁形照
      vinImgList: [], // 非微信端Vin照
      breakBeamImgList: [], // 非微信端断梁照
      otherImgList: [], // 非微信端其它照
      destruction_video: [], // 毁形视频
      wxEntireCarPhotos: "", // 微信端整车照
      wxUnmakePhotos: "", // 微信端毁形照
      wxVinPhotos: "", // 微信端Vin照
      break_beam_photos: "", // 微信端断梁照
      otherImgurl: "", // 微信端其它照
      voice: "", // 语音
      voiceShow: false, // 是否显示语音播报
      wximagelocalids: [], // 判断上传张数
      toast: null, // loading 转圈圈
      isdefault: "", // 是否允许录入
      ischu: 2, // 是否显示更多录入资料 （1：隐藏 2： 显示）
      CarInfoShow: false, // 是否显示车辆列表
      imageFileArr: [],
      repetition: [],
      carListData: [], // 车辆信息列表
      carPlate: "", // 车辆信息列表车牌号搜索
      du4: "",
      // testURl: "https://img.yzcdn.cn/vant/cat.jpeg",
      fileList3: [],
      myCopyVindata: "",
    };
  },
  created() {
    // isWechat 是否是微信端
    if (this.isWechat) {
      this.wcConfig(); // 此方法在utils目录下mixin中,且此方法挂载为全局mixins
    }
    this.getTypeInAuthority();
    this.getCarListData();
  },
  watch: {
    // 图片上传张数监听，显示loading效果
    wximagelocalids: {
      handler(newValue) {
        if (newValue.length > 0) {
          this.toast = Toast.loading({
            duration: 0, // 持续展示 toast
            forbidClick: true,
            message: "上传中...",
          });
          this.wxUpload(newValue[0]);
        } else {
          this.toast.clear();
        }
      },
      deep: true,
    },
    // 监听 tabs切换时清空录入页面数据
    activeTabs: {
      handler(newValue) {
        console.log(newValue);
      },
    },
    vindata: {
      handler(newValue) {
        console.log(newValue);
        if (newValue) {
          localStorage.setItem("myVin", newValue);
        } else {
          localStorage.removeItem("myVin");
        }
        this.myCopyVindata = newValue;
      },
      deep: true,
    },
  },
  methods: {
    // 清空录入信息
    refreshPage() {
      this.getCarListData();
      this.ischu = 2;
      this.isData.carNumberPlate = "";
      this.vindata = "";
      this.entireCarImgList = [];
      this.wxEntireCarPhotos = "";
      this.unmakeImgList = [];
      this.wxUnmakePhotos = "";
      this.vinImgList = [];
      this.wxVinPhotos = "";
      this.breakBeamImgList = [];
      this.break_beam_photos = "";
      this.entireCarImgList = [];
      this.wxEntireCarPhotos = "";
      this.otherImgList = [];
      this.otherImgurl = "";
      this.destruction_video = [];
    },
    // 保存录入信息
    async saveTypeInInfo(type) {
      try {
        let saveObj = encipherMent(
          JSON.stringify({
            type,
            carNumberPlate: this.isData.carNumberPlate,
            vin: this.vindata,
            path: this.entireCarImgList.length
              ? this.entireCarImgList[0].url
              : this.wxEntireCarPhotos || "",
            destruction_photos: this.unmakeImgList.length
              ? this.unmakeImgList[0].url
              : this.wxUnmakePhotos || "",
            vin_photos: this.vinImgList.length
              ? this.vinImgList[0].url
              : this.wxVinPhotos || "",
            break_beam_photos: this.breakBeamImgList.length
              ? this.breakBeamImgList[0].url
              : this.break_beam_photos || "",
            other_photos: this.otherImgList.length
              ? this.otherImgList[0].url
              : this.otherImgurl || "",
            destruction_video: this.destruction_video,
          })
        );
        let param = new URLSearchParams();
        param.append("value", saveObj);
        const res = await is_post(
          "index.php/vehicles_upload/saveDestruction",
          param
        ).then((res) => res);
        if (res.code === 0) {
          this.$toast.success(res.msg);
          this.getCarListData();
          this.activeTabs = "list";
          this.refreshPage();
        } else {
          this.$toast.fail(res.msg);
        }
      } catch (err) {
        console.log(err);
        this.$toast.fail(err.msg);
      }
    },
    // 获取保存的车辆列表
    getCarListData(carNumberPlate) {
      this.$http
        .post("/index.php/filter/destructionList", { carNumberPlate })
        .then((res) => {
          if (res.data.code == 0) {
            let { data } = res.data.data;
            this.carListData = data;
          }
        });
    },
    // 车辆信息列表编辑
    editCarInfo(item) {
      this.activeTabs = "type-in";
      this.searchCarInfo(item.carNumberPlate);
    },
    // 搜索车牌号获取车辆信息
    async searchCarInfo(carVal) {
      let value =
        Object.prototype.toString.call(carVal).slice(8, -1) == "String"
          ? carVal
          : this.isData.carNumberPlate;
      try {
        await selVehicLesInfo({
          key: "carNumberPlate",
          value,
        }).then((res) => {
          if (res.data.code == 0 && res.data.data.length) {
            const { data } = res.data;
            let carInfoObj = data[0]; //车辆信息
            this.isData.carNumberPlate = carInfoObj.carNumberPlate || ""; //车牌号
            this.vindata = carInfoObj.vin || ""; // vin号
            this.destruction_video = carInfoObj.destruction_video
              ? [carInfoObj.destruction_video]
              : []; // 毁形视频
            if (!this.isWechat) {
              //!this.isWechat 非微信端处理照片
              // 整车照
              if (
                carInfoObj.vehicle_images.length &&
                carInfoObj.vehicle_images[0].length > 5
              ) {
                this.entireCarImgList = [
                  {
                    url: carInfoObj.vehicle_images[
                      carInfoObj.vehicle_images.length - 1
                    ],
                  },
                ];
              } else {
                this.entireCarImgList = [];
              }
              // 毁形照
              this.unmakeImgList = carInfoObj.destruction_photos
                ? [
                    {
                      url: carInfoObj.destruction_photos,
                    },
                  ]
                : [];
              // Vin照
              this.vinImgList = carInfoObj.vin_photos
                ? [
                    {
                      url: carInfoObj.vin_photos,
                    },
                  ]
                : [];
              // 断梁照
              this.breakBeamImgList = carInfoObj.break_beam_photos
                ? [
                    {
                      url: carInfoObj.break_beam_photos,
                    },
                  ]
                : [];
              if (this.breakBeamImgList.length) {
                if (this.breakBeamImgList[0].url) {
                  console.log(this.breakBeamImgList[0].url.length);
                }
              }
              // 其它照
              if (carInfoObj.other_photos.length) {
                if (carInfoObj.other_photos.indexOf(",") > -1) {
                  this.otherImgList = [
                    {
                      url: carInfoObj.other_photos.slice(
                        0,
                        carInfoObj.other_photos.indexOf(",")
                      ),
                    },
                  ];
                } else {
                  this.otherImgList = [
                    {
                      url: carInfoObj.other_photos,
                    },
                  ];
                }
              } else {
                this.otherImgList = [];
              }
            } else {
              // 微信端处理照片
              // 整车照
              this.wxEntireCarPhotos =
                carInfoObj.vehicle_images.length &&
                carInfoObj.vehicle_images[0].length > 5
                  ? carInfoObj.vehicle_images[0]
                  : "";
              this.wxUnmakePhotos = carInfoObj.destruction_photos
                ? carInfoObj.destruction_photos
                : ""; // 毁形照
              this.wxVinPhotos = carInfoObj.vin_photos
                ? carInfoObj.vin_photos
                : ""; // Vin照
              this.break_beam_photos = carInfoObj.break_beam_photos
                ? carInfoObj.break_beam_photos
                : ""; // 断梁照片
              // 其它照
              if (carInfoObj.other_photos.length) {
                if (carInfoObj.other_photos.indexOf(",") > -1) {
                  this.otherImgurl = carInfoObj.other_photos.slice(
                    0,
                    carInfoObj.other_photos.indexOf(",")
                  );
                } else {
                  this.otherImgurl = carInfoObj.other_photos;
                }
              } else {
                this.otherImgurl = "";
              }
            }
          } else {
            this.entireCarImgList = [];
            this.unmakeImgList = [];
            this.vinImgList = [];
            this.breakBeamImgList = [];
            this.otherImgList = [];
            this.wxEntireCarPhotos = ""; // 整车照
            this.wxUnmakePhotos = ""; // 毁形照
            this.wxVinPhotos = ""; // Vin照
            this.break_beam_photos = ""; // 断梁照片
            this.otherImgurl = ""; // 其它照片
            this.vindata = ""; // vin号
            this.destruction_video = []; // 毁形视频
          }
        });
      } catch (err) {
        throw new Error(err);
      }
    },

    // 车辆列表弹窗关闭
    colosepopup() {
      this.CarInfoShow = false;
    },
    // 录入更多资料
    enteringMore() {
      this.ischu = 1;
      this.$nextTick(() => {
        this.$refs.infoCarRef.getQuality(); // 打开录入更多资料时获取调用子组件的获取质检列表方法
      });
    },
    // 获取是否可以录入信息
    getTypeInAuthority() {
      this.$http.post("/index.php//setUp/info", { id: 18 }).then((res) => {
        if (res.data.code == 0) {
          this.isdefault = res.data.data.default;
        } else if (res.data.code == -1) {
          this.islogout();
        } else {
          this.$toast.fail(res.data.msg);
        }
      });
    },
    // 识别车架号,此方法调用在utils目录下mixin中
    isVin(e) {
      var toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中...",
      });
      let text = `车架号：${e}`;
      this.$http.post("index.php/wechat/makeYuYin", { text }).then((res) => {
        this.voice = res.data.data;
        toast.clear(); //清除加载效果
        var u = navigator.userAgent;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isiOS) {
          this.voiceShow = true;
        } else {
          this.$nextTick(() => {
            this.$refs.audioRef.play(); // 非ios终端设备播放音频
          });
        }
      });
    },
    // 返回上一页
    goOut() {
      this.$router.push("/Recognition");
    },
    // 非微信端上传照片
    uploadershang(i) {
      return (file) => {
        var toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: "上传中...",
        });
        let params = new FormData(); //创建form对象
        params.append("file", file.file);
        this.$http
          .post("/index.php/index/upload/index", params)
          .then((res) => {
            toast.clear(); //清除加载效果
            if (res.data.code == 0) {
              if (i == "hui") {
                this.unmakeImgList = [{ url: res.data.data }]; //毁形照片
              } else if (i == "du") {
                let url = "index.php/vehicles_upload/vehicleCarNumberPlate";
                this.du4 = res.data.data;
                this.$nextTick(() => {
                  this.$refs.infoCarRef.wxEntireCarPhotos = this.du4;
                });
                this.entireCarImgList = [{ url: res.data.data }]; //整车照片
                this.recognition(url, { path: res.data.data });
              } else if (i == "vin") {
                let url = "/index.php/index/bid_management.bid_order/apiBaiDu";
                this.wxVinPhotos = res.data.data;
                if (this.isdefault == "是") {
                  this.$nextTick(() => {
                    this.$refs.infoCarRef.wxVinPhotos = this.wxVinPhotos;
                  });
                }
                this.vinImgList = [{ url: res.data.data }]; //Vin照片
                if (this.vindata == "") {
                  this.recognition(url, { url: res.data.data }, "vin");
                }
              } else if (i == "duan") {
                this.break_beam_photos = res.data.data;
                this.breakBeamImgList = [{ url: res.data.data }]; //断梁照片
              } else if (i == "other") {
                // this.otherImgurl = res.data.data
                this.otherImgList = [{ url: res.data.data }]; //其他照片
              }

              file.status = "done";
            } else if (res.data.code == -1) {
              deleteCookie("token");
              this.$toast.fail(res.data.msg);
              this.$router.push("/");
            } else {
              if (i == "du") {
                this.du4 = "";
                this.entireCarImgList = [];
              } else if (i == "hui") {
                this.wxUnmakePhotos = "";
                this.unmakeImgList = [];
              } else if (i == "vin") {
                this.wxVinPhotos = "";
                this.vinImgList = [];
              } else if (i == "duan") {
                this.break_beam_photos = "";
                this.breakBeamImgList = [];
              }
              this.$toast.fail(res.data.msg);
            }
          })
          .catch(() => {
            if (i == "du") {
              this.du4 = "";
              this.entireCarImgList = [];
            } else if (i == "hui") {
              this.wxUnmakePhotos = "";
              this.unmakeImgList = [];
            } else if (i == "duan") {
              this.wxVinPhotos = "";
              this.vinImgList = []; //行驶证正面照片
            }
            toast.clear(); //清除加载效果
            this.$toast.fail("网络开小差了，请稍后重试！");
            // file.status = "failed";
            // file.message = "上传失败";
          });
      };
    },
    // 毁形视频上传
    afterRead(file) {
      // 上传状态
      this.fileLoading = true;
      file.status = "uploading";
      // 状态提示
      file.message = "上传中...";
      // 声明form表单数据
      const formData = new FormData();
      // 添加文件信息
      formData.append("file", file.file);
      // 上传接口调用
      const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: "上传...",
      });
      this.$http
        .post("/index.php/index/upload_vedio/index", formData, {
          timeout: 1200000,
        })
        .then((res) => {
          // 存储返回数据
          file.content = res.data.data;
          this.destruction_video.push(res.data.data);
          file.status = "done";
          this.fileLoading = false;
          toast.clear();
        })
        .catch(() => {
          toast.clear();
        });
    },
    // 毁形视频上传前
    beforeRead(file) {
      if (
        file.type == "video/mp4" ||
        file.type == "video/mov" ||
        file.type == "video/webm" ||
        file.type == "video/ogg" ||
        file.type == "video/quicktime"
      ) {
        return true;
      } else {
        this.$toast.fail("请上传视频！");
      }
      return false;
    },
    // 毁形视频删除
    iconClose(i) {
      this.destruction_video.splice(i, 1);
      this.fileList3.splice(i, 1);
    },
    // 播放音频
    playVoice() {
      this.$refs.audioRef.play();
      this.voiceShow = false;
    },
    comeWei() {
      this.CarInfoShow = false;
      this.setInfo();
    },
    upDate(e) {
      this.vindata = e[0];
      this.CarInfoShow = false;
      this.setInfo();
    },
    infoOk() {
      this.onsubmit();
    },
    async setInfo() {
      try {
        let data = encipherMent(
          JSON.stringify({
            carNumberPlate: this.isData.carNumberPlate,
            vin: this.vindata,
            path: this.entireCarImgList.length
              ? this.entireCarImgList[0].url
              : this.wxEntireCarPhotos || "",
            destruction_photos: this.unmakeImgList.length
              ? this.unmakeImgList[0].url
              : this.wxUnmakePhotos || "",
            vin_photos: this.vinImgList.length
              ? this.vinImgList[0].url
              : this.wxVinPhotos || "",
            break_beam_photos: this.breakBeamImgList.length
              ? this.breakBeamImgList[0].url
              : this.break_beam_photos || "",
            other_photos: this.otherImgList.length
              ? this.otherImgList[0].url
              : this.otherImgurl || "",
            destruction_video: this.destruction_video,
          })
        );
        let param = new URLSearchParams();
        param.append("value", data);
        const res = await is_post(
          "index.php/vehicles_upload/saveDestruction",
          param
        ).then((res) => res);

        if (res.code === 0) {
          this.$router.push("/Recognition");
          this.$toast.success(res.msg);
        } else {
          this.$toast.fail(res.msg);
        }
      } catch (err) {
        this.$toast.fail(err.msg);
      }
    },
    async onsubmit() {
      const { data } = await PlateNum({
        value: this.isData.carNumberPlate,
      }).then((res) => res);
      console.log(data);
      let arr = data.data;
      if (arr.length == 0) {
        this.setInfo();
      } else if (arr.length == 1) {
        if (
          arr[0].carNumberPlate == this.isData.carNumberPlate &&
          arr[0].vin == this.vindata
        ) {
          this.setInfo();
        } else {
          this.repetition = arr;
          this.CarInfoShow = true;
          this.$nextTick(() => {
            this.$refs.ObtainRef.checkbox = [];
          });
        }
      } else if (arr.length > 1) {
        this.repetition = arr;
        this.CarInfoShow = true;
        this.$nextTick(() => {
          this.$refs.ObtainRef.checkbox = [];
        });
      }
    },
    wxUpload(localId) {
      var this_ = this;
      wx.ready(function () {
        // 需在用户可能点击分享按钮前就先调用
        wx.uploadImage({
          localId: localId, // 需要上传的图片的本地ID，由 chooseImage 接口获得
          isShowProgressTips: 1, // 默认为1，显示进度提示
          success: async function (res) {
            var serverId = res.serverId; // 返回图片的服务器端ID
            try {
              const { data } = await this_.$http
                .post("/index.php/index/upload/index", { media_id: serverId })
                .then((res) => res);
              if (data.code == 0) {
                if (this_.islable == "45Degrees") {
                  //45°照
                  if (this_.idsIndex == 9) {
                    this_.path = data.data;
                  } else {
                    let url = "index.php/vehicles_upload/vehicleCarNumberPlate";
                    this_.wxEntireCarPhotos = data.data;
                    this_.recognition(url, { path: data.data });
                  }
                } else if (this_.islable == "duan") {
                  //锻炼
                  this_.break_beam_photos = data.data; //没有特定规定的照片  走这个数组进行循环渲染
                } else if (this_.islable == "Vin") {
                  //VIN
                  if (this_.idsIndex == 9) {
                    this_.vin_photos = data.data;
                  } else {
                    let url =
                      "/index.php/index/bid_management.bid_order/apiBaiDu";
                    this_.wxVinPhotos = data.data;
                    alert("我是vin信息", this_.vindata);
                    alert("我是vin信息", window);
                    alert("我是vin信息", window.localStorage.getItem("myVin"));
                    if (!this_.vindata) {
                      this_.recognition(url, { path: data.data }, "vin");
                    }
                  }
                } else if (this_.islable == "hui") {
                  //毁形照
                  if (this_.idsIndex == 9) {
                    this_.destruction_photos = data.data;
                  } else {
                    this_.wxUnmakePhotos = data.data;
                  }
                } else if (this_.islable == "other") {
                  //毁形照
                  if (this_.idsIndex == 9) {
                    this_.destruction_photos = data.data;
                  } else {
                    this_.otherImgurl = data.data;
                  }
                }
                this_.wximagelocalids.splice(this_.wximagelocalids[0], 1); //上传完成之后删除当前这个
              } else {
                this_.$toast.error(data.msg);
                this_.toast.clear();
              }
            } catch {
              this_.toast.clear();
            }
          },
        });
      });
    },
    // 非微信端删除图片
    deleteimg(i) {
      return () => {
        if (i == 1) {
          this.entireCarImgList = [];
          this.du4 = "";
          this.isData = {};
        } else if (i == 2) {
          this.unmakeImgList = [];
        } else if (i == 3) {
          // this.vindata = "";
          this.vinImgList = [];
        } else if (i == 4) {
          this.breakBeamImgList = [];
        } else if (i == 5) {
          // 其他照片
          this.otherImgList = [];
        }
      };
    },
    //删除
    delImgHan(v, i) {
      console.log(i);
      switch (v) {
        case "45Degrees":
          this.wxEntireCarPhotos = "";
          break;
        case "hui":
          this.wxUnmakePhotos = "";
          break;
        case "Vin":
          this.wxVinPhotos = "";
          break;
        case "duan":
          this.break_beam_photos = "";

          break;
        case "carInfo":
          this.imageUrl = "";

          this.carInfo_photos = "";
          break;
        case "other":
          this.otherImgurl = "";
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  z-index: 9;
  width: calc(100% - 40px);
  padding: 0 20px;
  background-color: cadetblue;
  height: 1rem;
  line-height: 1rem;
  color: white;
  font-size: 0.4rem;
  display: flex;
  justify-content: space-between;

  span {
    display: inline-block;
  }

  span:nth-child(1) {
    width: 30px;
    height: 30px;
    background-image: url(../../assets/u39.png);
    background-size: 100%;
    margin-top: 8px;
  }

  .music-t {
    position: fixed;
    top: -52px;
    left: 75%;
    z-index: 9;
    color: orangered;
    font-size: 2rem;
  }
}

.car-list-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
  width: 96%;
  margin-right: 4%;
}

.car-list-item {
  width: 96%;
  background-color: #dde3e9;
  margin-left: 2%;
  margin-top: 2%;
  border-radius: 8px;

  .item-edge-distance {
    padding: 4px;
    padding-bottom: 5px;

    .item-icon {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 5px;
      font-weight: bold;
    }
  }
}

.plate-vin-box {
  display: flex;
  align-items: center;
  width: 100%;

  .left-input {
    width: 77%;
  }

  .right-search {
    width: 20%;
  }
}

.content-box {
  width: 100%;

  .img-box {
    display: flex;
    flex-wrap: wrap;
    text-align: center;

    .img-item {
      width: 33%;
      // flex: 1;
      .iconX {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 16px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.7);
        border-radius: 0 0 0 0.24rem;
      }
    }
  }
}

.videobox {
  position: relative;

  .videoP {
    width: 100%;
    height: 195px;
  }

  .iconX {
    position: absolute;
    top: 0;
    right: 0;
    background: #000;
    color: #fff;
    z-index: 99999;
  }
}

.opopzi {
  text-align: center;
  color: #1989fa;
}

// van-uploader组件 上传前图片样式
::v-deep .van-uploader__upload {
  width: 120px;
  height: 120px;
}

// van-uploader组件 上传后图片样式
::v-deep .van-uploader__preview-image {
  width: 120px;
  height: 120px;
}
</style>
